export default function IconTicketsActive() {
  return (
    <svg
      viewBox="0 0 16 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"   
      width="18"
      height="20"   
    >
      <path
        id="Vector"
        d="M14.8967 4.28623C15.1492 4.23214 15.3759 4.09104 15.5389 3.8865C15.7019 3.68196 15.7913 3.42639 15.7923 3.16249V1.3874C15.7923 1.08367 15.6743 0.792383 15.4644 0.577614C15.2544 0.362844 14.9697 0.242188 14.6728 0.242188H1.23897C0.942065 0.242188 0.65732 0.362844 0.447375 0.577614C0.237431 0.792383 0.119486 1.08367 0.119486 1.3874V3.16249C0.120418 3.42639 0.209864 3.68196 0.372874 3.8865C0.535884 4.09104 0.76258 4.23214 1.01507 4.28623C1.39318 4.36645 1.73272 4.57752 1.97647 4.8839C2.22023 5.19028 2.35332 5.57324 2.35332 5.96827C2.35332 6.3633 2.22023 6.74626 1.97647 7.05264C1.73272 7.35902 1.39318 7.57009 1.01507 7.65031C0.76258 7.7044 0.535884 7.8455 0.372874 8.05004C0.209864 8.25458 0.120418 8.51015 0.119486 8.77405V10.5491C0.119486 10.8529 0.237431 11.1442 0.447375 11.3589C0.65732 11.5737 0.942065 11.6944 1.23897 11.6944H14.6728C14.9697 11.6944 15.2544 11.5737 15.4644 11.3589C15.6743 11.1442 15.7923 10.8529 15.7923 10.5491V8.77405C15.7913 8.51015 15.7019 8.25458 15.5389 8.05004C15.3759 7.8455 15.1492 7.7044 14.8967 7.65031C14.5186 7.57009 14.179 7.35902 13.9353 7.05264C13.6915 6.74626 13.5584 6.3633 13.5584 5.96827C13.5584 5.57324 13.6915 5.19028 13.9353 4.8839C14.179 4.57752 14.5186 4.36645 14.8967 4.28623ZM1.23897 8.77405C1.87164 8.64263 2.44044 8.2915 2.849 7.78015C3.25756 7.26881 3.48075 6.62869 3.48075 5.96827C3.48075 5.30785 3.25756 4.66774 2.849 4.15639C2.44044 3.64504 1.87164 3.29391 1.23897 3.16249V1.3874H5.15717V10.5491H1.23897V8.77405Z"
        fill="url(#paint0_linear_382_1045)"
      ></path>
      <defs>
        <linearGradient
          id="paint0_linear_382_1045"
          x1="1.21085"
          y1="9.88665"
          x2="13.0431"
          y2="6.59112"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ED1C24"></stop>
          <stop offset="0.26" stopColor="#EC281E"></stop>
          <stop offset="0.73" stopColor="#EC480E"></stop>
          <stop offset="1" stopColor="#EC5E04"></stop>
        </linearGradient>
      </defs>
    </svg>
  );
}
